var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Overview",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/Overview</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Icon/Overview" fill="#000000">
      <g id="Overview">
        <rect id="Rectangle-5" x="2" y="4" width="2" height="2"/>
        <rect id="Rectangle-5-Copy-5" x="2" y="1" width="18" height="2"/>
        <rect id="Rectangle-5-Copy" x="2" y="7" width="2" height="4"/>
        <rect id="Rectangle-5-Copy-2" x="2" y="12" width="2" height="3"/>
        <rect id="Rectangle-5-Copy-3" x="2" y="16" width="2" height="4"/>
        <rect id="Rectangle-5-Copy-10" x="18" y="4" width="2" height="2"/>
        <rect id="Rectangle-5-Copy-9" x="18" y="7" width="2" height="4"/>
        <rect id="Rectangle-5-Copy-8" x="18" y="12" width="2" height="3"/>
        <rect id="Rectangle-5-Copy-7" x="6" y="4" width="2" height="2"/>
        <rect id="Rectangle-5-Copy-4" x="6" y="7" width="2" height="4"/>
        <rect id="Rectangle-5-Copy-12" x="6" y="12" width="2" height="3"/>
        <rect id="Rectangle-5-Copy-13" x="10" y="4" width="2" height="2"/>
        <rect id="Rectangle-5-Copy-16" x="14" y="4" width="2" height="2"/>
        <rect id="Rectangle-5-Copy-15" x="10" y="7" width="2" height="4"/>
        <rect id="Rectangle-5-Copy-17" x="14" y="7" width="2" height="2"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/Overview.svg